import { useState } from "react";
import styles from "../styles/Footer.module.css";
import Modal from "./Modal";
import PrivacyPolicy from "./PrivacyPolicy";

export default function Footer() {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <footer className={styles.footer}>
      <div className={styles.inner}>
        <div className={styles.left}>
          <span className={styles.label}>Get in touch</span>
          <span className={styles.line} />
        </div>

        <a
          href="mailto:krzysztof.m.chabowski@gmail.com"
          className={styles.emailBtn}
        >
          Email Me
          <span className={styles.chev}>›</span>
        </a>

        <div className={styles.right}>
          <span className={styles.line} />
          <a
            href="https://www.linkedin.com/in/krzysztof-chabowski"
            target="_blank"
            rel="noopener noreferrer"
            className={styles.iconBtn}
            aria-label="LinkedIn"
          >
            in
          </a>
        </div>
      </div>

      <div className={styles.legal}>
        <span className={styles.copyright}>
          © {new Date().getFullYear()} Krzysztof M. Chabowski
        </span>

        <span className={styles.legalSeparator}>·</span>

        <button
          type="button"
          className={styles.legalButton}
          onClick={() => setIsOpen(true)}
        >
          Privacy Policy
        </button>
      </div>

      {isOpen && (
        <Modal onClose={() => setIsOpen(false)}>
          <PrivacyPolicy />
        </Modal>
      )}
    </footer>
  );
}
